import { ApiError } from '../../lib/api';

/** Vytáhne český detail z FastAPI chyby ({ detail: "..." }), jinak vrátí fallback. */
export function apiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    const detail = (err.detail as { detail?: unknown } | null)?.detail;
    if (typeof detail === 'string') return detail;
    return fallback;
  }
  return 'Nelze se spojit se serverem.';
}
